import {defineStore} from 'pinia'

const name = 'appInbox'

let init = {
  records: [],
  unread: 0,
  loaded: false,
}

export const useAppInboxStore = defineStore(name, {
  id: name,

  state: () => ({...init}),

  actions: {
    load(payload) {
      this.records = payload?.notifications || []
      this.unread = payload?.unread || 0
      this.loaded = true
    },
    // Nouvelle notif temps-réel (WebSocket) : en tête de liste + badge.
    prepend(notif) {
      if (!notif) return
      if (this.records.some(n => n.id === notif.id)) return
      this.records.unshift(notif)
      if (!notif.read) this.unread += 1
    },
    markRead(id) {
      const n = this.records.find(r => r.id === id)
      if (n && !n.read) {
        n.read = true
        this.unread = Math.max(0, this.unread - 1)
      }
    },
    markAllRead() {
      this.records.forEach(n => { n.read = true })
      this.unread = 0
    },
    remove(id) {
      const idx = this.records.findIndex(r => r.id === id)
      if (idx === -1) return
      if (!this.records[idx].read) this.unread = Math.max(0, this.unread - 1)
      this.records.splice(idx, 1)
    },
  },

  getters: {
    getRecords: (state) => state.records,
    hasUnread: (state) => state.unread > 0,
  },
})
